import { SearchOutlined } from "@ant-design/icons";
import { Button, DatePicker, DatePickerProps } from "antd";
import { RangePickerProps } from "antd/lib/date-picker";
import Select from "antd/lib/select";
import Title from "antd/lib/typography/Title";
import moment from "moment";
import React from "react";
import { ReportQuery } from "service/queries";
import { translate } from "utils";
import { BaseChartHeaderProps } from "./types";
import { CHART_FILTERS } from "../../constants";
const { Option } = Select;

const BaseChartHeader: React.FC<BaseChartHeaderProps> = ({
	className,
	title,
	updateFilter,
	filter,
	updateReport,
}) => {
	const handleChangeReportType = (newType: string) => {
		filter && updateFilter({ ...filter, reportType: newType });
	};

	const handleChange = (
		value: DatePickerProps["value"] | RangePickerProps["value"],
		dateString: string | [string, string],
	) => {
		const newFilter = { ...filter } as ReportQuery;
		newFilter.startYear = dateString[0].split("-")[0];
		newFilter.endYear = dateString[1].split("-")[0];

		switch (filter?.reportType) {
		case "date":
			updateFilter({
				...newFilter,
				startDate: dateString[0],
				endDate: dateString[1],
			});
			break;
		case "month":
			updateFilter({
				...newFilter,
				startMonth: dateString[0].split("-")[1],
				endMonth: dateString[1].split("-")[1],
			});
			break;
		case "quarter":
			updateFilter({
				...newFilter,
				startQuarter: dateString[0].split("Q")[1],
				endQuarter: dateString[1].split("Q")[1],
			});
			break;
		case "year":
			updateFilter({
				...newFilter,
				startYear: dateString[0],
				endYear: dateString[1],
			});
			break;
		default:
			break;
		}
	};

	const getFilterTime = () => {
		switch (filter?.reportType) {
		case "date":
			return (
				<DatePicker.RangePicker
					defaultValue={[moment(filter.startDate), moment(filter.endDate)]}
					onChange={handleChange}
				/>
			);
		case "month":
			return (
				<DatePicker.RangePicker picker="month" onChange={handleChange} />
			);
		case "quarter":
			return (
				<DatePicker.RangePicker
					picker="quarter"
					onChange={handleChange}
					defaultValue={[
						moment().quarter(Number.parseInt(filter.startQuarter)),
						moment().quarter(Number.parseInt(filter.endQuarter)),
					]}
				/>
			);
		case "year":
			return <DatePicker.RangePicker picker="year" onChange={handleChange} />;
		default:
			return;
		}
	};

	const handleUpdateReport = () => {
		updateReport && updateReport();
	};

	return (
		<div className={`mb-5 ${className}`}>
			<div>
				<Title level={4}>{title}</Title>
			</div>
			<div className="flex justify-end gap-5">
				<Select value={filter?.reportType} onChange={handleChangeReportType}>
					{CHART_FILTERS.map((f, index) => (
						<Option key={index} value={f.value}>
							{translate(f.label)}
						</Option>
					))}
				</Select>

				{getFilterTime()}

				<Button
					shape="circle"
					icon={<SearchOutlined />}
					onClick={handleUpdateReport}
				/>
			</div>
		</div>
	);
};

export default BaseChartHeader;
